import(/* webpackMode: "eager" */ "/app/src/app/resources/(with-layout)/layout.tsx");
